// extracted by mini-css-extract-plugin
export default {"pdd_item":"Rules_pdd_item__i1hxP","theme_list":"Rules_theme_list__4127H","mobile_pdd_section":"Rules_mobile_pdd_section__8fTYO","mobile_theme_list":"Rules_mobile_theme_list__s3MVf"};